// extracted by mini-css-extract-plugin
export var container = "_27-0";
export var disabled = "_27-4";
export var fullWidth = "_27-3";
export var lined = "_27-1";
export var selected = "_27-5";
export var tab = "_27-2";